import { render, staticRenderFns } from "./PageTree.vue?vue&type=template&id=6528b7e2&scoped=true&"
import script from "./PageTree.vue?vue&type=script&lang=js&"
export * from "./PageTree.vue?vue&type=script&lang=js&"
import style0 from "./PageTree.vue?vue&type=style&index=0&id=6528b7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528b7e2",
  null
  
)

export default component.exports